import { ReadingChoices } from '../ReadingChoices';
import { OpenReading } from '../ReadingChoices/open';

export function Body({ questions, questionIndex }) {
  const { choices, questionText, questionType, openQuestionAnswer } =
    questions?.[questionIndex] ?? {};
  const isOpen = questionType == 'open';

  return !isOpen ? (
    <ReadingChoices questionText={questionText} choices={choices} />
  ) : (
    <OpenReading
      questionIndex={questionIndex}
      questionText={questionText}
      openQuestionAnswer={openQuestionAnswer}
    />
  );
}
